<template>
  <div>
    <h1>
      Настройки
    </h1>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>